var $ffc147749052dc62$exports = {};
$ffc147749052dc62$exports = {
    "clear": `\u{6E05}\u{9664}`,
    "invalid": `(\u{7121}\u{6548})`,
    "loading": `\u{6B63}\u{5728}\u{8F09}\u{5165}...`,
    "noResults": `\u{7121}\u{4EFB}\u{4F55}\u{7D50}\u{679C}`
};


export {$ffc147749052dc62$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
